import { render } from "./market-switcher.vue?vue&type=template&id=59ec1924"
import script from "./market-switcher.vue?vue&type=script&lang=js"
export * from "./market-switcher.vue?vue&type=script&lang=js"

import exportComponent from "/home/djordje/code/uwp/lyle-and-scott/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__